import React, { useCallback, lazy, Suspense } from "react";
import { isEmpty } from "lodash";

import { useStateSelector } from "utils/field";

import Drawer from "components/Drawer";
import Button from "components/Button";
import LoadingSection from "components/Loading/LoadingSection";
import Accordion from "components/Accordion";
import FileSharing from "./FileSharing";
import ErrorFlagging from "./ErrorFlagging";
import VersionHistory from "./VersionHistory";

import classes from "./style.module.scss";
import sharedClasses from "features/Model/sharedStyles.module.scss";

import HousesSelect from "assets/images/icons/JSX/HousesSelect";

const LazyLoadedModelDefaults = lazy(() => import("./ModelDefaults"));

const Settings = ({ change, open = false, toggleOpen }) => {
    const organization = useStateSelector(`user.organization`) || {};
    const { REVERT_MODEL_ENABLED = true } = useStateSelector(`user.userPermissions`) || {};

    const handleClose = useCallback(() => {
        toggleOpen();
    }, [toggleOpen]);

    return (
        <Drawer open={open} title="Settings" subtitle="Model Settings" close={handleClose}>
            {!isEmpty(organization) && <FileSharing />}
            <Accordion
                className={sharedClasses.accordion}
                heading={
                    <div className={sharedClasses.accordionIconHeading}>
                        Default Model Codes <HousesSelect />
                    </div>
                }
                large
            >
                <Suspense fallback={<LoadingSection sectionLoadingName={<h3>Loading Default Model Codes</h3>} />}>
                    <LazyLoadedModelDefaults change={change} />
                </Suspense>
            </Accordion>

            {/* {REVERT_MODEL_ENABLED && <VersionHistory />} */}

            {/* <ErrorFlagging /> */}
            <div className={classes.buttonRow}>
                <Button onClick={handleClose} type="hollow">
                    Close
                </Button>
            </div>
        </Drawer>
    );
};

export default Settings;
